module.exports = "/_next/static/images/tree-duotone-421f6c585fb24dd7653599f85bb17f00.svg";